// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShareAltOutlinedSvg from "@fishx/icons-svg/es/asn/ShareAltOutlined";
import FishxIcon from '../components/FishxIcon';

var ShareAltOutlined = function ShareAltOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShareAltOutlinedSvg
  }));
};

ShareAltOutlined.displayName = 'ShareAltOutlined';
export default React.forwardRef(ShareAltOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShareAltOutlined.js
// module id = 4098
// module chunks = 0